import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// SERVICES
import { ThemeService } from './services/theme.service';
import { NavigationService } from "./services/navigation.service";
import { RoutePartsService } from './services/route-parts.service';
import { AuthGuard } from './guards/auth.guard';
import { UserRoleGuard } from './guards/user-role.guard';
import { AppConfirmService } from './services/app-confirm/app-confirm.service';
import { ModalWrapperComponent} from './services/modal-wrapper/modal-wrapper-component'
import { AppLoaderService } from './services/app-loader/app-loader.service';
import { BancoService } from './services/banco.service';
import { BlackListService } from './services/blacklist.service';
import { AgenciaService } from './services/agencia.service';
import { TipoCobrancaService } from './services/tipo-cobranca.service';
import { ListaPrecoService } from './services/lista-preco.service';
import { ClassificacaoGerencialService } from './services/classificacao-gerencial.service';
import { ListagemSolicitacoesService } from './services/listagem-solicitacoes.service';
import { ComprasVendasService } from './services/compra-venda.service';


import { SharedComponentsModule } from './components/shared-components.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SecurePipe } from 'app/secure.pipe';
import { HighlightPipe } from 'app/highlight.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { AppLoaderProgressService } from './services/app-loader-progress/app-loader-progress.service';
import { ListaPrecoTabelaService } from './services/lista-preco-tabela.service';
import { ListagemProdutoService } from './services/listagem-produto.service';
import { ApuracaoResultadosService } from './services/apuracao-resultados.service';
import { ListagemContasReceberPagarService } from './services/listagem-contas-receber-pagar.service';
import { RazaoClasseGerencialService } from './services/razao-classe-gerencial.service';
import { ListagemCadastrosService } from './services/listagem-cadastros.service';
import { DfContraCnpjService } from './services/df-contra-cnpj.service';
import { CadastroFileViewComponent } from './components/file-view/cadastro-file-view.component';
import { InfokawSearchSelectComponent } from './components/infokaw-search-select/infokaw-search-select.component';



@NgModule({
  imports: [
  CommonModule,
    SharedPipesModule,
    SharedDirectivesModule,  
    ReactiveFormsModule,
  ],
  providers: [
    ThemeService,
    NavigationService,
    RoutePartsService,
    AuthGuard,
    UserRoleGuard,
    AppConfirmService,
    AppLoaderService,
    ModalWrapperComponent,
    AppLoaderProgressService,
    BancoService,
    BlackListService,
    AgenciaService,
    TipoCobrancaService,
    ListaPrecoService,
    ListaPrecoTabelaService,
    ClassificacaoGerencialService,
    ListagemSolicitacoesService,
    ComprasVendasService,
    ListagemProdutoService,
    ApuracaoResultadosService,
    ListagemContasReceberPagarService,
    RazaoClasseGerencialService,
    ListagemCadastrosService,
    DfContraCnpjService
    ],
  exports: [
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule
  ],
})
export class SharedModule { }
